import { parseISO } from "date-fns";

interface DataPoint {
  x: Date
  y: number
}

interface ApiDataEntry {
  date: string
  total: number
}

interface ApiData {
  grouping: string
  start_date: string
  end_date: string
  data: ApiDataEntry[]
}

interface Dataset {
  label: string
  data: DataPoint[]
  grouping: string
}

interface DataGroup {
  datasets: Dataset[]
}

interface ParsedData {
  datasets: Record<string, DataGroup>
}

function fillIfEmpty(array: DataPoint[], start: Date, end: Date): void {
  if (!array.length) {
    array.push({
      x: start,
      y: 0,
    });

    array.push({
      x: end,
      y: 0,
    });
  }
}

export function parseData(apiData: ApiData): ParsedData {
  const tenantData: DataPoint[] = [];
  const dataGroups: Record<string, DataGroup> = {
    new_tenants: {
      datasets: [
        {
          label: "Novos Clientes",
          data: tenantData,
          grouping: apiData.grouping,
        },
      ],
    },
  };

  const startDate = parseISO(apiData.start_date);
  const endDate = parseISO(apiData.end_date);

  const data = apiData.data;
  for (const entry of data) {
    const date = parseISO(entry.date);
    tenantData.push({
      x: date,
      y: entry.total,
    });
  }

  for (const dataGroup in dataGroups) {
    for (const dataset of dataGroups[dataGroup].datasets) {
      fillIfEmpty(dataset.data, startDate, endDate);
      dataset.grouping = apiData.grouping;
    }
  }

  return {
    datasets: dataGroups,
  };
}
